import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthenticationService } from '../../services/authentication/authentication.service';

export const notAuthGuard: CanActivateFn = (route, state) => {
  const isAuthenticated = inject(AuthenticationService);
  const router = inject(Router);

  if (!isAuthenticated.isUserLoggedIn()) {
    return true;
  } else {
    router.navigate(['/tabs/home'], {
      state: { reloadType: 'full' }
    });
    return false;
  }
};
